export enum EstadoCivilEnum {
  solteiro = "Solteiro(a)",
  casado = "Casado(a)",
  uniao_estavel = "União estável",
  divorciado = "Divorciado(a)",
  viuvo = "Viúvo(a)"
}
